import type { FinanceStatisticsEntity } from "@/modules/finances/entities/financeStatisticsEntity"

export type TransactionsResumeCardModel = {
  monthlyRevenue: number
  monthlyRevenueAtCounter: number
  monthlyRevenueFees: number
  monthlyRevenueRefunds: number
  monthlyRevenueSepa: number
}

export function createTransactionsResumeCardModel(stats: FinanceStatisticsEntity | null): TransactionsResumeCardModel {
  if (!stats)
    return {
      monthlyRevenue: 0,
      monthlyRevenueAtCounter: 0,
      monthlyRevenueFees: 0,
      monthlyRevenueRefunds: 0,
      monthlyRevenueSepa: 0,
    }
  return {
    monthlyRevenue: stats.stats.netTotal,
    monthlyRevenueAtCounter: stats.stats.outOfBandTotal,
    monthlyRevenueFees: stats.stats.feesTotal,
    monthlyRevenueRefunds: stats.stats.refundTotal,
    monthlyRevenueSepa: stats.stats.sepaDebitAmountTotal,
  }
}
